<template>
  <div id="app">
    <heading ref='header'></heading>
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
export default {
  name: "App",
  components: {
    'heading': Header
  }
};
</script>

<style lang='scss' src="../public/css/main.scss"></style>
